export default __webpack_public_path__ + "static/me-1318baebca58bcecfced2001d37a77d0.webp";